import { Component, EventEmitter, HostListener, Inject, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { MapService } from 'src/app/shared/components/molecules/map/service/map.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SesionService } from 'src/app/core/service/sesion.service';
import { Coordinates, PotentialCustomer } from '../potential-customer/model/potential-customer';
import { ResultGoogle } from 'src/app/shared/components/molecules/map/model/map-model';

@Component({
  selector: 'app-confirm-location',
  templateUrl: './confirm-location.component.html',
  styleUrls: ['./confirm-location.component.scss'],
})
export class ConfirmLocationComponent implements OnInit, OnDestroy {
  @ViewChild(GoogleMap, { static: false }) map!: GoogleMap;
  submitted: boolean;
  mapForm: FormGroup;
  showStateWarning: boolean = false;

  private streetSearchSubject = new Subject<string>();
  private streetSearchSubscription: Subscription | undefined;
  mapOptions: any = {
    center: { lat: -23.5505, lng: -46.6333 },
    zoom: 17,
    mapTypeControlOptions: { mapTypeIds: [] },
    disableDefaultUI: true,
    mapTypeControl: true,
    scaleControl: true,
    mapTypeId: 'roadmap',
    clickableIcons: false,
    draggableCursor: 'crosshair',
  };
  street: string | undefined;
  streetNumber: string | undefined;

  @Output()
  onBack = new EventEmitter();

  @Output()
  onComplete = new EventEmitter<number>();

  zoom: number;
  potentialCustomerData: PotentialCustomer | null;
  markerPosition: any = null;
  apiLoaded: Observable<boolean>;
  showErrorConfirm: boolean = false;
  data?: { coordinates: any; address: string; streetNumber: string };
  constructor(
    private fb: FormBuilder,
    private mapService: MapService,
    private readonly sesion: SesionService,
  ) {
    this.zoom = 17;
    this.submitted = false;
    this.potentialCustomerData = this.sesion.getItem('potential_customer');
    this.data = {
      coordinates: this.potentialCustomerData?.location.coordinates,
      address: this.potentialCustomerData?.location.street
        ? `${this.potentialCustomerData?.location.street} ${this.potentialCustomerData?.location.streetNumber?.toString()}`
        : '',
      streetNumber: this.potentialCustomerData?.location.streetNumber?.toString() ?? '',
    };

    if (this.data.coordinates) {
      this.mapOptions.center = { lat: this.data.coordinates.lat, lng: this.data.coordinates.lon };
      this.markerPosition = {
        lat: this.data.coordinates.lat,
        lng: this.data.coordinates.lon,
      };
    }
    this.apiLoaded = mapService.googleMapsDinamicApi();
    this.mapForm = this.fb.group({
      locationStreet: [this.data.address, Validators.maxLength(60)],
    });
  }

  zommChangedMap() {
    this.zoom = this.map.getZoom() ?? 17;
  }

  ngOnInit(): void {
    this.streetSearchSubscription = this.streetSearchSubject
      .pipe(debounceTime(1000), distinctUntilChanged())
      .subscribe(() => {
        this.parseDirection();
      });
  }

  ngOnDestroy(): void {
    this.streetSearchSubscription?.unsubscribe();
  }

  formComplete() {
    this.onComplete.emit(3);
  }

  onChangeStreet(event: any) {
    console.log('onChangeStreet', event);
    const streetValue = this.mapForm.get('locationStreet')?.value;
    this.streetSearchSubject.next(streetValue);
  }

  mapClick(event: any) {
    let latLng = event.latLng.toJSON();
    console.log('latLNG', latLng);
    this.markerPosition = latLng;
    this.zoom = this.zoom < 17 ? 17 : this.zoom;
    if (this.map) this.map.panTo(latLng);
    this.mapService.getDirectionWithCordinates(latLng.lat, latLng.lng).subscribe((dataTwo) => {
      let postCode: string = '';
      for (let result of dataTwo.results[0].address_components) {
        if (result.types.includes('postal_code')) postCode = result.long_name;
      }
      console.log('response getDirectionWithCordinates', dataTwo);
      this.parseResultMap(dataTwo, this.markerPosition);
    });
  }

  parseResultMap(data: ResultGoogle, coordinates?: { lat: number; lng: number }) {
    let streetNumber: string | undefined, route: string | undefined;
    for (let result of data.results[0].address_components) {
      console.log('result: ', result);
      switch (true) {
        case result.types.includes('street_number'):
          streetNumber = result.long_name;
          console.log('streetNumber', streetNumber);
          break;
        case result.types.includes('route'):
          route = result.long_name;
          console.log('route', route);
          break;
        default:
          break;
      }
    }
    if ((streetNumber && route) || route) {
      const direction = streetNumber ? `${route} ${streetNumber}` : route;
      this.street = route;
      this.streetNumber = streetNumber ?? undefined;
      this.mapForm.get('locationStreet')?.setValue(direction);
    }
  }

  back() {
    this.onBack.emit();
  }

  parseDirection() {
    let street = this.mapForm.get('locationStreet')?.value;
    let cp = this.potentialCustomerData?.location.postCode;
    let state = this.potentialCustomerData?.location.city;
    let city = this.potentialCustomerData?.location.state;
    let country = 'BR';
    const directParse = [street, city, state, cp, country].filter(Boolean).join(', ');

    this.mapService.getDirection(directParse).subscribe((data) => {
      if (data.status == 'OK') {
        let resultTypeStreetNumber = data.results[0].address_components.find((result: any) =>
          result.types.includes('street_number'),
        );
        let resultTypeStreet = data.results[0].address_components.find((result: any) => result.types.includes('route'));
        if ((resultTypeStreet && resultTypeStreetNumber) || resultTypeStreet) {
          this.markerPosition = {
            lat: data.results[0].geometry.location.lat,
            lng: data.results[0].geometry.location.lng,
          };

          if (resultTypeStreet && resultTypeStreetNumber) {
            this.street = resultTypeStreet?.long_name;
            console.log('street', this.street);
            this.streetNumber = resultTypeStreetNumber?.long_name;
            console.log('streetNumber', this.streetNumber);
            this.mapForm.get('locationStreet')?.setValue(`${this.street} ${this.streetNumber}`);
          }

          this.map.panTo(this.markerPosition);
          this.zoom = 17;
        }
      }
    });
  }

  async onSubmit() {
    if (this.mapForm.valid) {
      console.log('onsubmitedd');
      const coordinate: Coordinates = {
        lat: this.markerPosition.lat,
        lon: this.markerPosition.lng,
      };
      const streetValue = this.mapForm.get('locationStreet')?.value;
      const { number: streetNumber, streetName } = this.extractNumberStreet(streetValue);
      console.log('streetNumber', streetNumber);
      console.log('streetName', streetName);
      if (this.potentialCustomerData && coordinate) {
        this.potentialCustomerData.location.coordinates = coordinate;
      }
      if (this.potentialCustomerData && streetName) {
        this.potentialCustomerData.location.street = streetName;
      }
      if (this.potentialCustomerData && streetNumber) {
        this.potentialCustomerData.location.streetNumber = streetNumber;
      }
      if (this.potentialCustomerData) {
        this.sesion.setItem<PotentialCustomer>('potential_customer', this.potentialCustomerData);
      }
      this.submitted = true;
      this.formComplete();
    }
  }

  extractNumberStreet(street: string): { number: number; streetName: string } {
    const value = street.trim();
    const valueLower = value.toLowerCase();

    if (/(^|\s)(km|kilómetro|kilometro)\s*\d+$/i.test(valueLower)) {
      return { number: 0, streetName: value };
    }

    const match = value.match(/\s*(\d+)$/);
    if (match) {
      const streetName = value.slice(0, match.index).trim();
      return { number: Number(match[1]), streetName };
    }
    return { number: 0, streetName: value };
  }
}
